import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LeftTree',
  props: {
    database: {
      // 数据来源
      type: Object,
      require: true,
      default: function _default() {}
    },
    defaultExpOrgPathId: {
      // 默认展开部门显示人员
      type: String,
      default: ''
    },
    selectId: {
      // 初始化选中机构加选中样式 值: nodeId
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String / Number,
      default: '0'
    },
    rootOrgId: {
      // 根机构限定
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String / Number,
      default: '100000'
    },
    multiple: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      rootId: [],
      defaultProps: {
        label: 'cityName',
        children: 'city'
      },
      chooseNode: {},
      rootData: [],
      initRootData: []
    };
  },
  created: function created() {
    var _this = this;
    this.$API.getRequest({
      url: '/punish/administrativePunish/lawEnforcementRegion'
    }).then(function (res) {
      _this.rootData = res.result;
    });
  },
  mounted: function mounted() {},
  methods: {
    // eslint-disable-next-line no-empty-function
    loadNode: function loadNode() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleNodeClick: function handleNodeClick(data) {
      this.$emit('pickNode', data);
    }
  }
};